import { useNavigate } from 'react-router';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { RequestEvaluationDto } from '../../../commonTypes/user.types';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

const useHttpRequestEvaluation = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();
    const { t } = useTranslation('evaluations');

    const exec = (body: RequestEvaluationDto) => {
        const { exec, abort } = userApi.requestEvaluation({
            body,
            onSuccess: () => {
                toastHandler.push('success', t('requestEvaluationTitle'), t('requestEvaluationSucceded'));
                navigate(`/evaluation`);
            },
            onError: (error: AppError | string) => {
                if (isErrorCode(error, ErrorCodes.EVALUATION_EVALUATEE_MISSING)) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationEvaluateeMissing'));
                } else if (isErrorCode(error, ErrorCodes.EVALUATION_DUE_DATE_MISSING)) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationDueDateMissing'));
                } else if (isErrorCode(error, ErrorCodes.EVALUATION_EVALUATOR_ROLE_MISSING)) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationEvaluatorRoleMissing'));
                } else if (isErrorCode(error, ErrorCodes.EVALUATION_TOPIC_MISSING)) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationTopicMissing'));
                } else if (isErrorCode(error, ErrorCodes.EVALUATION_EVALUATOR_MISSING)) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationEvaluatorMissing'));
                } else {
                    // Use backend-provided userMessage
                    toastHandler.push('error', t('requestEvaluationTitle'), getUserMessage(error, t('requestEvaluationFailed')));
                }
            },
        });
        exec();
        return abort;
    };
    return { exec };
};

export default useHttpRequestEvaluation;
